import script from "./GroupWizardProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupWizardProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./GroupWizardProgressBar.vue?vue&type=style&index=0&id=29a386c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a386c8"]])

export default __exports__